import { render, staticRenderFns } from "./stateData.vue?vue&type=template&id=2b6a67c0&scoped=true&"
import script from "./stateData.vue?vue&type=script&lang=js&"
export * from "./stateData.vue?vue&type=script&lang=js&"
import style0 from "./stateData.vue?vue&type=style&index=0&id=2b6a67c0&scoped=true&lang=css&"
import style1 from "./stateData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6a67c0",
  null
  
)

export default component.exports